module.exports = __webpack_public_path__ + "static/media/TheWidowsPrayer.8167cb66.jpg";